<ng-container *ngFor="let i of [].constructor(index)">
  <div class="p-seatmap-seat-type__link-title" style="border-radius: 0px; margin-top: 8px">
    <div class="p-modal-seatmap-detail__head-lead">
      <table class="c-plan-table01 c-plan-table01--4col js-plan-table01">
        <thead class="c-plan-table01__head">
          <tr class="c-plan-table01__inner">
            <th class="c-plan-table01__col" scope="col">
              <div class="c-plan-table01__col-item c-plan-table01__col--em">
                <span class="c-flight-info01__title-airport-arrival c-loading-bar__line"> </span>
              </div>
            </th>
            <td class="c-plan-table01__col">
              <div class="c-plan-table01__col-inner"></div>
            </td>
          </tr>
        </thead>
      </table>
    </div>
    <div class="p-modal-seatmap-detail__head-lead">
      <span class="c-flight-info01__title-airport-arrival c-loading-bar__line"> </span>
    </div>
    <div class="p-modal-seatmap-detail__head-lead">
      <table class="c-plan-table01 c-plan-table01--4col js-plan-table01">
        <thead class="c-plan-table01__head">
          <tr class="c-plan-table01__inner">
            <th class="c-plan-table01__col" scope="col">
              <div class="c-plan-table01__col-item c-plan-table01__col--em">
                <span class="c-flight-info01__title-airport-arrival c-loading-bar__line"> </span>
              </div>
            </th>
            <td class="c-plan-table01__col">
              <div class="c-plan-table01__col-inner"></div>
            </td>
          </tr>
        </thead>
      </table>
    </div>
    <div class="p-modal-seatmap-detail__head-lead">
      <table class="c-plan-table01 c-plan-table01--4col js-plan-table01">
        <thead class="c-plan-table01__head">
          <tr class="c-plan-table01__inner">
            <th class="c-plan-table01__col" scope="col">
              <div class="c-plan-table01__col-item c-plan-table01__col--em">
                <span class="c-flight-info01__title-airport-arrival c-loading-bar__line"> </span>
              </div>
            </th>
            <td class="c-plan-table01__col">
              <div class="c-plan-table01__col-inner"></div>
            </td>
          </tr>
        </thead>
      </table>
    </div>
  </div>
</ng-container>
